import { ReadStream } from 'fs';

export interface MetadataResponse {
  version: string;
  environment: string;
}

export interface ConversationParticipantDetails {
  id: string;
  role?: string;
  displayName?: string;
  isKnown?: boolean;
  voiceMessageOut?: boolean;
}

export interface ConversationParticipant {
  primary: ConversationParticipantDetails[];
  secondary?: ConversationParticipantDetails[];
}

export interface Conversation {
  id: string;
  subject: string;
  owner: string;
  participants: ConversationParticipant;
  status: string;
  isRead: boolean;
  nbMessages: number;
  creationDate: number;
  hasAttachments: boolean;
  lastMessageDisplayName: string;
  lastMessageReceivedContent: string;
  lastMessageReceivedDate: number;
  lastMessageStatus: string;
  lastUpdateDate: number;
}

export interface ConversationsResponse {
  data: {
    conversations: Conversation[];
  };
  metadata: MetadataResponse;
}

export interface Attachment {
  contentRef: string;
  filename: string;
  contentType: string;
  size: number;
}

export interface AudioMessage {
  contentRef?: string;
  fileName: string;
  contentType: string;
  size?: number;
}

export interface MessageContent {
  text?: string;
  html: string;
  attachments: Attachment[];
  audioMessage?: AudioMessage;
}

export interface Participant {
  id: string;
  type: string;
  voiceMessageOut?: boolean;
}

export enum MessageStatusType {
  Received = 'RECEIVED',
  Draft = 'DRAFT',
  Sent = 'SENT',
}

export interface MessageParticipant {
  id: string;
  role?: string;
  displayName?: string;
  isKnown?: boolean;
  type: string;
  voiceMessageOut?: boolean;
}

export interface Message {
  id: string;
  receivedDate: number;
  clientReadDate: number;
  status: MessageStatusType;
  messageContent: MessageContent;
  sender: MessageParticipant;
  noReply: boolean;
  primaryParticipantReadDate?: number;
  participants: MessageParticipant[];
}

export interface CreateConversationResponse {
  data: Conversation;
  metadata: MetadataResponse;
}

export interface CreateConversationWithMessageResponse {
  data: {
    conversation: Conversation;
    message: Message;
  };
  metadata: MetadataResponse;
}

export interface ConversationMessagesResponse {
  data: {
    messages: Message[];
  };
  metadata: MetadataResponse;
}

export interface CreateMessageResponse {
  data: Message;
  metadata: MetadataResponse;
}

export interface StreamResponse {
  data: ReadStream;
  contentType: string;
  contentDisposition: string;
}

export interface CreateAttachementResponse {
  contentRef: string;
  filename: string;
  contentType: string;
  size: number;
}

export interface ConversationMessage {
  id: string;
  text: string;
  receivedDate: string;
}

export interface ConversationMessages {
  id: string;
  subject: string;
  messages: ConversationMessage[];
}

export interface ConversationsMessagesResponse {
  data: {
    conversations: ConversationMessages[];
  };
  metadata: MetadataResponse;
}
